import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { gql, graphql } from 'react-apollo';

import { Route, Link, Switch } from 'react-router-dom';

import MenuItem from 'material-ui/MenuItem';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';

import HomePage from './HomePage';
import TownsList from '../Components/TownsList';
import Town from '../Components/Town';
import BatchesList from '../Components/BatchList';
import Loader from '../UI/Loader';
import TournamentCriteria from '../Components/TournamentCriteria';
import Divider from 'material-ui/Divider';

const tournamentsQuery = gql`
    query TournamentsQuery {
        tournaments {
            _id
            number
            p {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            m {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            t {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            v {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
        }
    }
`;

class JuryHomePage extends Component {
    static propTypes = {
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
    };

    render() {
        const {
            history,
            user,
            data: { loading, tournaments: allTournaments },
        } = this.props;

        if (loading) {
            return <Loader centerX />;
        }

        const tournaments = allTournaments.filter(t => t.number >= 39).sort((a, b) => b.number - a.number);
        const lastTournamentNumber = tournaments[0].number;

        return (
            <HomePage
                menuItems={
                    <Fragment>
                        <Switch>
                            <Route
                                path="/tournaments/:number"
                                render={({ match }) => (
                                    <Fragment>
                                        <MenuItem
                                            onClick={() => history.push(`/tournaments/${match.params.number}/batches`)}
                                        >
                                            <FormattedMessage id="AdminHomePage.BatchesList" />
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => history.push(`/tournaments/${match.params.number}/towns`)}
                                        >
                                            <FormattedMessage id="AdminHomePage.TownsList" />
                                        </MenuItem>
                                        <MenuItem
                                            rightIcon={<ArrowDropRight />}
                                            menuItems={
                                                <Fragment>
                                                    {tournaments.map(tournament => (
                                                        <MenuItem
                                                            onClick={() =>
                                                                history.push(`/tournaments/${tournament.number}`)
                                                            }
                                                            checked={tournament.number === match.params.number}
                                                            insetChildren={true}
                                                        >
                                                            {tournament.number}
                                                            -й Турнир
                                                        </MenuItem>
                                                    ))}
                                                </Fragment>
                                            }
                                        >
                                            {match.params.number}
                                            -й Турнир
                                        </MenuItem>
                                    </Fragment>
                                )}
                            />
                            <Route
                                path="/"
                                render={() => (
                                    <Fragment>
                                        <MenuItem
                                            onClick={() => history.push(`/tournaments/${lastTournamentNumber}/batches`)}
                                        >
                                            <FormattedMessage id="AdminHomePage.BatchesList" />
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => history.push(`/tournaments/${lastTournamentNumber}/towns`)}
                                        >
                                            <FormattedMessage id="AdminHomePage.TownsList" />
                                        </MenuItem>
                                        <MenuItem
                                            rightIcon={<ArrowDropRight />}
                                            menuItems={
                                                <Fragment>
                                                    {tournaments.map(tournament => (
                                                        <MenuItem
                                                            onClick={() =>
                                                                history.push(`/tournaments/${tournament.number}`)
                                                            }
                                                            checked={tournament.number === lastTournamentNumber}
                                                            insetChildren={true}
                                                        >
                                                            {tournament.number}
                                                            -й Турнир
                                                        </MenuItem>
                                                    ))}
                                                </Fragment>
                                            }
                                        >
                                            {lastTournamentNumber}
                                            -й Турнир
                                        </MenuItem>
                                    </Fragment>
                                )}
                            />
                        </Switch>
                        <Divider />
                        <MenuItem
                            containerElement={
                                <a
                                    target="_blank"
                                    href={`https://docs.google.com/forms/d/e/1FAIpQLSfQAEQcQP748UXDY6LAuSprftfH2QdG9eTpthnXzEU240V-YA/viewform?usp=pp_url&entry.1931807854=${
                                        user.name ? encodeURIComponent(user.name) : ''
                                    }&entry.1709222661=${new Date().toISOString().split('T')[0]}`}
                                />
                            }
                        >
                            Учёт часов
                        </MenuItem>
                    </Fragment>
                }
            >
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={props => (
                            <Fragment>
                                {tournaments.map(tournament => (
                                    <Fragment>
                                        <Tournament
                                            {...props}
                                            tournament={tournament}
                                            user={user}
                                            key={tournament.number}
                                        />
                                        <br />
                                    </Fragment>
                                ))}
                            </Fragment>
                        )}
                    />
                    <Route
                        path="/tournaments/:number"
                        render={props => (
                            <Tournament
                                {...props}
                                tournament={tournaments.find(
                                    tournament => tournament.number === Number(props.match.params.number)
                                )}
                                user={user}
                            />
                        )}
                    />
                </Switch>
            </HomePage>
        );
    }
}

function Tournament({ tournament, user, match }) {
    return (
        <Switch>
            <Route
                exact
                path="/tournaments/:number/batches"
                render={props => <BatchesList {...props} tournament={tournament} user={user} />}
            />
            <Route
                exact
                path="/tournaments/:number/towns"
                render={props => <TownsList {...props} tournament={tournament} />}
            />
            <Route
                path="/tournaments/:number/criteria"
                render={props => <TournamentCriteria {...props} tournament={tournament} />}
            />
            <Route
                exact
                path={match.url}
                render={() => (
                    <Fragment>
                        <h1>
                            {tournament.number}
                            -й Турнир
                        </h1>
                        <Link to={`/tournaments/${tournament.number}/batches`}>Пачки</Link>
                        <br />
                        <Link to={`/tournaments/${tournament.number}/towns`}>Города</Link>
                        <br />
                        <br />
                        <Link to={`/tournaments/${tournament.number}/criteria`}>Критерии</Link>
                        <br />
                    </Fragment>
                )}
            />
            <Route path="/tournaments/:number/towns/:id/:season" render={props => <Town {...props} user={user} />} />
        </Switch>
    );
}

export default graphql(tournamentsQuery)(JuryHomePage);



// WEBPACK FOOTER //
// ./src/Pages/JuryHomePage.js